import { isAutomatedBrowser } from 'utils/automation';

/**
 * Starts Datadog RUM (and Session Replay) for the signed-in user.
 *
 * `DD_RUM_INIT` is injected at deploy time (app/terraform/dd_rum_snippet.template)
 * and is the only path that initializes the SDK, so returning early here is
 * what keeps automated E2E runs out of RUM entirely: no session, no replay.
 */
export function identifyUser(user) {
  if (isAutomatedBrowser()) {
    return;
  }

  if (window.DD_RUM_INIT) {
    window.DD_RUM_INIT(() => window.DD_RUM?.setUser?.({
      id: user.id,
      name: `${user.firstName} ${user.lastName}`,
      email: user.emailAddress,
      companyName: user.Company.name,
      companyCode: user.Company.code,
      companyId: user.companyId,
    }));
  }
}

export function reportError(...args) {
  console.error(...args);
}

/**
 * Sends a custom RUM action; it counts only once identifyUser has started RUM, which this must never do.
 * `addAction?.`: until the SDK loads, `DD_RUM` is the snippet's stub, and a throw would cancel a caller's reload.
 */
export function reportAction(name, context) {
  window.DD_RUM?.addAction?.(name, context);
}
